"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.beCompanyNumberChecker = void 0;
var ONDERNEMINGSNUMMER_REGEX = /^[01]\d{9}$/;
var beCompanyNumberChecker = exports.beCompanyNumberChecker = function beCompanyNumberChecker(companyNumber) {
  return ONDERNEMINGSNUMMER_REGEX.test(companyNumber);
};